import { call, put, takeLatest } from "redux-saga/effects";
import {
  productQuantityAddSuccess,
  productQuantityAddFailure,
  productQuantityEditSuccess,
  productQuantityEditFailure,
  productQuantityDeleteSuccess,
  productQuantityDeleteFailure,
  productQuantityViewSuccess,
  productQuantityViewFailure,
  productQuantityViewAllSuccess,
  productQuantityViewAllFailure,
  productQuantitySearchViewAllSuccess,
  productQuantitySearchViewAllFailure,
} from "./ProductQuantityAction";

import {
  PRODUCT_QUANTITY_ADD_REQUEST,
  PRODUCT_QUANTITY_EDIT_REQUEST,
  PRODUCT_QUANTITY_DELETE_REQUEST,
  PRODUCT_QUANTITY_VIEW_REQUEST,
  PRODUCT_QUANTITY_VIEW_ALL_REQUEST,
  PRODUCT_QUANTITY_SEARCH_REQUEST,
} from "./ProductQuantityTypes";

import {
  AddProductQuantityEffect,
  EditProductQuantityEffect,
  DeleteProductQuantityEffect,
  ViewProductQuantityEffect,
  ViewAllProductsQuantityEffect,
  ViewAllSearchProductsQuantityEffect,
} from "./ProductQuantityEffect";

function* addQuantitySaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      AddProductQuantityEffect,
      action.payload,
      config
    );
    yield put(productQuantityAddSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to add quantity";
    yield put(
      productQuantityAddFailure({ errormessage: message, errorFields })
    );
  }
}

function* editQuantitySaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const { quantityId } = action.payload;
    const {
      id,
      product_id,
      status,
      type_of_quantity,
      measurements,
      type_of_alcohol_id,
      brand_id,
      wholesaler_id,
    } = quantityId;
    const formData = {
      product_id,
      status,
      type_of_quantity,
      measurements,
      type_of_alcohol_id,
      brand_id,
      wholesaler_id,
    };
    const response = yield call(
      EditProductQuantityEffect,
      id,
      formData,
      config
    );
    yield put(productQuantityEditSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to edit quantity";
    yield put(
      productQuantityEditFailure({ errormessage: message, errorFields })
    );
  }
}

function* viewQuantitySaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewProductQuantityEffect,
      action.payload,
      config
    );
    yield put(productQuantityViewSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch quantity details";
    yield put(productQuantityViewFailure({ errormessage: errorMessage }));
  }
}

function* viewAllQuantitiesSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewAllProductsQuantityEffect,
      action.payload,
      config
    );
    yield put(productQuantityViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch quantities";
    yield put(productQuantityViewAllFailure({ errormessage: errorMessage }));
  }
}

function* viewAllSearchQuantitiesSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewAllSearchProductsQuantityEffect,
      action.payload,
      config
    );
    yield put(productQuantitySearchViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch quantities";
    yield put(
      productQuantitySearchViewAllFailure({ errormessage: errorMessage })
    );
  }
}

function* deleteQuantitySaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      DeleteProductQuantityEffect,
      action.payload,
      config
    );
    yield put(productQuantityDeleteSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to delete quantity";
    yield put(productQuantityDeleteFailure({ errormessage: errorMessage }));
  }
}

export function* ProductQuantitySaga() {
  yield takeLatest(PRODUCT_QUANTITY_ADD_REQUEST, addQuantitySaga);
  yield takeLatest(PRODUCT_QUANTITY_EDIT_REQUEST, editQuantitySaga);
  yield takeLatest(PRODUCT_QUANTITY_DELETE_REQUEST, deleteQuantitySaga);
  yield takeLatest(PRODUCT_QUANTITY_VIEW_REQUEST, viewQuantitySaga);
  yield takeLatest(PRODUCT_QUANTITY_VIEW_ALL_REQUEST, viewAllQuantitiesSaga);
  yield takeLatest(
    PRODUCT_QUANTITY_SEARCH_REQUEST,
    viewAllSearchQuantitiesSaga
  );
}
